module.exports = __webpack_public_path__ + "static/media/15UN-Habitat5.81fe76dd.jpg";